import React, { useState } from "react";
import Amplify from "aws-amplify";
import awsconfig from "../../aws-config";
import { store } from "react-notifications-component";
import Joi from "@hapi/joi";

Amplify.configure(awsconfig);

const initialFormState = { code: "" };

const schema = { code: Joi.string().alphanum().min(3).max(30).required() };

export default function ConfirmCode({ userInfo, hideLoadingValue, showLoadingValue, history }, props) {
  const [form, setForm] = useState(initialFormState);
  const [errors, setErrors] = useState({});

  const handleChange = ({ currentTarget: input }) => {
    const errorMessage = validateProperty(input);
    if (errorMessage) {
      setErrors({
        ...errors,
        [input.name]: errorMessage,
      });

    } else {
      delete errors[input.name];
      setErrors(errors);
    }

    setForm({
      ...form,
      [input.name]: input.value,
    });
  };

  const handleSendRequest = async (post) => {
    try {
      showLoadingValue();
      const user = await Amplify.Auth.confirmSignUp(userInfo.user.username, form.code);
      console.log(user);
      localStorage.setItem("userInfo", JSON.stringify(user));
      history.push("/app");
    } catch (error) {
      store.addNotification({
        title: "Error!",
        showIcon: true,
        message: error.message,
        type: "danger",
        insert: "top",
        container: "top-center",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: true,
        },
      });
    }
    hideLoadingValue();
  };

  const handleResendCode = async (post) => {
    try {
      showLoadingValue();
      const { user } = await Amplify.Auth.resendSignUp(userInfo.user.username);
      setForm(initialFormState);
      console.log(user);
    } catch (error) {
      store.addNotification({
        title: "Error!",
        showIcon: true,
        message: error.message,
        type: "danger",
        insert: "top",
        container: "top-center",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: true,
        },
      });
    }
    hideLoadingValue();
  };

  const validateProperty = ({ name, value }) => {
    const userInputObject = { [name]: value };
    const propertySchema = Joi.object({ [name]: schema[name] });
    const { error } = propertySchema.validate(userInputObject, {
      abortEarly: true,
    });
    return error ? error.details[0].message : null;
  };

  if (userInfo == undefined) {
    history.push("/auth/register");
    return "";
  }

  return (
    <>
      <div className="login-container" style={{ paddingTop: "10px" }}>
        <h4 className="auth-header-page">Confirm</h4>
        <h4 className="auth-header-page">Code</h4>
        <div className="form-login-section">
          <div className="row">
            <span>We have sent a code by email to {userInfo.codeDeliveryDetails.Destination}. Enter it below to confirm your account.</span>
          </div>
          <div className="row">
            <input
              type="text"
              className="auth-form-controller"
              name="code"
              placeholder="Verification Code"
              onChange={handleChange}
              value={form.code}
            />
            {errors.name && <span className="red-text">{errors.name}</span>}
          </div>
          <div className="row">
            <div className="col s12 center-align padding0">
              <button
                className="waves-effect waves-light submit-button"
                onClick={handleSendRequest}
              >
                Confirm Account
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col s7 padding0">
            Didn't receive a code?{" "}
            <button
                className="waves-effect waves-light submit-button"
                onClick={handleResendCode}
              >
                RESEND IT
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
